import WalletAiStats from "./WalletAiStats";

export default WalletAiStats;